<div class="outline-editor" [class.has-error]="!!error()">
  <textarea
    #editor
    class="outline-textarea"
    [value]="displayText()"
    [disabled]="disabled()"
    (input)="onInput($event)"
    (keydown)="onKeydown($event)"
    (click)="onSelectionChange()"
    (keyup)="onSelectionChange()"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [attr.aria-label]="translations().editorAriaLabel"
    [attr.aria-invalid]="error() ? 'true' : null"
  ></textarea>

  @if (error()) {
    <div class="outline-error" role="status">
      {{ getErrorMessage(error()) }} ({{ translations().lineLabel }} {{ error()?.line }})
    </div>
  }
</div>
